import {
  Close as CloseIcon,
  NotificationImportant as NotificationImportantIcon,
} from "@mui/icons-material";
import { Alert, Link } from "@mui/material";
import { RefreshJobNotifications } from "models/refreshJobNotifications";
import { FC } from "react";
import { FormattedMessage, useIntl } from "react-intl";

type RefreshJobAlertProps = {
  dismissNotification: (key: string, tab: string | null) => void;
  refreshJobNotifications: RefreshJobNotifications;
};

export const RefreshJobAlert: FC<RefreshJobAlertProps> = (props) => {
  const { dismissNotification, refreshJobNotifications } = props;
  const intl = useIntl();

  return (
    <>
      {refreshJobNotifications.symptomText && (
        <Link
          component="button"
          onClick={() => {
            dismissNotification("symptomText", "details");
          }}
          sx={{
            width: 1,
          }}
          data-testid="RefreshJobAlert-SymptomText"
        >
          <Alert
            sx={{
              width: 1,
              borderRadius: 0,
            }}
            variant="filled"
            severity="info"
            icon={<NotificationImportantIcon fontSize="inherit" />}
            action={
              <div
                style={{ margin: "auto", display: "flex", alignItems: "center" }}
                color="inherit"
                onClick={(e) => {
                  e.stopPropagation();
                  dismissNotification("symptomText", null);
                }}
                data-testid="RefreshJobAlert-SymptomTextDismiss"
              >
                {intl.formatMessage({ id: "refreshJob.alert.dismiss" })}
                <CloseIcon />
              </div>
            }
          >
            <FormattedMessage id="refreshJob.alert.symptomText" />
          </Alert>
        </Link>
      )}
      {refreshJobNotifications.internalNotes && (
        <Link
          component="button"
          onClick={() => {
            dismissNotification("notes", "notes");
          }}
          sx={{
            width: 1,
          }}
          data-testid="RefreshJobAlert-Notes"
        >
          <Alert
            sx={{
              width: 1,
              borderRadius: 0,
            }}
            variant="filled"
            severity="info"
            icon={<NotificationImportantIcon fontSize="inherit" />}
            action={
              <div
                style={{ margin: "auto", display: "flex", alignItems: "center" }}
                color="inherit"
                onClick={(e) => {
                  e.stopPropagation();
                  dismissNotification("notes", null);
                }}
                data-testid="RefreshJobAlert-NotesDismiss"
              >
                {intl.formatMessage({ id: "refreshJob.alert.dismiss" })}
                <CloseIcon />
              </div>
            }
          >
            <FormattedMessage id="refreshJob.alert.notes" />
          </Alert>
        </Link>
      )}
      {refreshJobNotifications.files && (
        <Link
          component="button"
          onClick={() => {
            dismissNotification("files", "files");
          }}
          sx={{
            width: 1,
          }}
          data-testid="RefreshJobAlert-Files"
        >
          <Alert
            sx={{
              width: 1,
              borderRadius: 0,
            }}
            variant="filled"
            severity="info"
            icon={<NotificationImportantIcon fontSize="inherit" />}
            action={
              <div
                style={{ margin: "auto", display: "flex", alignItems: "center" }}
                color="inherit"
                onClick={(e) => {
                  dismissNotification("files", null);
                }}
                data-testid="RefreshJobAlert-FilesDismiss"
              >
                {intl.formatMessage({ id: "refreshJob.alert.dismiss" })}
                <CloseIcon />
              </div>
            }
          >
            <FormattedMessage id="refreshJob.alert.files" />
          </Alert>
        </Link>
      )}
      {refreshJobNotifications.preOrderedParts && (
        <Link
          component="button"
          onClick={() => {
            dismissNotification("parts", "parts");
          }}
          sx={{
            width: 1,
          }}
          data-testid="RefreshJobAlert-Parts"
        >
          <Alert
            sx={{
              width: 1,
              borderRadius: 0,
            }}
            variant="filled"
            severity="info"
            icon={<NotificationImportantIcon fontSize="inherit" />}
            action={
              <div
                style={{ margin: "auto", display: "flex", alignItems: "center" }}
                color="inherit"
                onClick={(e) => {
                  dismissNotification("parts", null);
                }}
                data-testid="RefreshJobAlert-PartsDismiss"
              >
                {intl.formatMessage({ id: "refreshJob.alert.dismiss" })}
                <CloseIcon />
              </div>
            }
          >
            <FormattedMessage id="refreshJob.alert.parts" />
          </Alert>
        </Link>
      )}
    </>
  );
};
